const isExternalLink = (link) => {
  if(link) {
    return (link.host !== window.location.host);
  }
  return false;
}
const links = document.querySelectorAll('.c-widget a:not(.c-card):not(.c-card-grid__item),a.c-nav__link.c-nav__link--nested')

let i;
if (links) {
  for (i = 0; i <= links.length; ++i) {
    if (isExternalLink(links[i])) {
      if (links[i].protocol !== 'mailto:' && links[i].protocol !== 'tel:') {
        if(!links[i].classList.contains('c-btn')){
          links[i].innerHTML += ' &#8599;';
          links[i].target = '_blank';
        }
      }
    }
  }
}

const cardLinks = document.querySelectorAll('a.c-card--project');
if (cardLinks) {
  for (i = 0; i <= cardLinks.length; ++i) {
    if (isExternalLink(cardLinks[i])) {
      if (cardLinks[i].protocol !== 'mailto:' && cardLinks[i].protocol !== 'tel:') {
        const headline = cardLinks[i].querySelector('.c-card__headline');
        if(headline) {
          headline.innerHTML += ' &#8599;';
        }
      }
    }
  }
}
